import myProfile from "./myProfile.json";
import header from "./header.json";
import changePassword from "./changePassword.json";
import common from "./common.json";
import sideBar from "./sideBar.json";
import footer from "./footer.json";
import transactions from "./transactions.json";
import betHistory from "./betHistory.json";
import lobby from "./lobby.json";
import game from "./game.json";
import payment from "./payment.json";

const translationsEN = {
  ...myProfile,
  ...header,
  ...changePassword,
  ...common,
  ...sideBar,
  ...footer,
  ...transactions,
  ...betHistory,
  ...lobby,
  ...game,
  ...payment,
};

export default translationsEN;
